function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a28144e2-4b9a-4a7c-a9b1-67db1abdfea2,.bfa39c7d-176f-4da9-882e-4f185d91c762{fill:#fff;}.b775ec73-27bd-4df9-88ce-1c5a347d8879,.ba8c1a1e-146c-40a9-ad04-af0100cf39e5{fill:#012;}.b775ec73-27bd-4df9-88ce-1c5a347d8879{stroke:#000;stroke-width:5px;}.a28144e2-4b9a-4a7c-a9b1-67db1abdfea2,.b775ec73-27bd-4df9-88ce-1c5a347d8879{stroke-miterlimit:10;}.a28144e2-4b9a-4a7c-a9b1-67db1abdfea2{stroke:#012;stroke-width:20px;}"));

var _ref3 = /*#__PURE__*/React.createElement("rect", {
  className: "bfa39c7d-176f-4da9-882e-4f185d91c762",
  x: 116.07,
  y: 182.75,
  width: 296.94,
  height: 272,
  rx: 12
});

var _ref4 = /*#__PURE__*/React.createElement("rect", {
  className: "bfa39c7d-176f-4da9-882e-4f185d91c762",
  x: 122.69,
  y: 165.75,
  width: 287.32,
  height: 95.36,
  rx: 12
});

var _ref5 = /*#__PURE__*/React.createElement("rect", {
  className: "bfa39c7d-176f-4da9-882e-4f185d91c762",
  x: 116.07,
  y: 443.86,
  width: 299.75,
  height: 27.17,
  rx: 12
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  className: "b775ec73-27bd-4df9-88ce-1c5a347d8879",
  d: "M269.62,164.41c42.45,0,82.1,4.16,111.33,11.72,17.62,4.54,26.82,9.07,30.84,11.72V450.94c-3.6,2.65-12.81,7.19-30.84,11.72-29.23,7.56-68.88,11.72-111.33,11.72s-82.1-4.16-111.33-11.72c-17.63-4.53-26.82-9.07-30.85-11.72v-263c3.61-2.65,12.82-7.18,30.85-11.72,29.23-7.56,68.87-11.72,111.33-11.72Zm0-15.12c-43.65,0-84.91,4.16-115.74,12.1-29.24,7.56-42.46,16.63-42.46,22.3V455.1c0,5.67,13.22,14.74,42.46,22.3C184.71,485,226,489.5,269.62,489.5s84.91-4.54,115.74-12.1c29.24-7.56,42.45-16.63,42.45-22.3V183.69c0-5.67-13.21-14.74-42.45-22.3-30.83-7.94-72.09-12.1-115.74-12.1Z"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  className: "ba8c1a1e-146c-40a9-ad04-af0100cf39e5",
  d: "M211.16,307.31a45,45,0,1,1,44.75-45.25v.09C255.91,286.82,235.83,307.31,211.16,307.31Zm0-73.19a28.44,28.44,0,1,0,28.43,28.45h0a28.47,28.47,0,0,0-28.43-28.44Z"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  className: "ba8c1a1e-146c-40a9-ad04-af0100cf39e5",
  d: "M320.73,307.31a45.17,45.17,0,1,1,45.17-45.17h0A45.24,45.24,0,0,1,320.73,307.31Zm0-73.19a28.44,28.44,0,1,0,28.44,28.44,28.44,28.44,0,0,0-28.44-28.44Z"
});

var _ref9 = /*#__PURE__*/React.createElement("circle", {
  className: "ba8c1a1e-146c-40a9-ad04-af0100cf39e5",
  cx: 211.16,
  cy: 262.15,
  r: 9.2
});

var _ref10 = /*#__PURE__*/React.createElement("circle", {
  className: "ba8c1a1e-146c-40a9-ad04-af0100cf39e5",
  cx: 320.75,
  cy: 262.16,
  r: 9.2,
  transform: "translate(10.58 536.76) rotate(-80.78)"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  className: "a28144e2-4b9a-4a7c-a9b1-67db1abdfea2",
  d: "M269.94,10C175.83,10,39.35,60.16,34.27,221.11l-9.78,4.61c-18.29,5.26-14,29.53-14.12,48.56L10,327.93v21.46c.14,23.75,39.8,20.1,63.55,20V371a9.76,9.76,0,0,0,9.81,9.69H98.69a9.75,9.75,0,0,0,9.79-9.71V225.71h0A9.76,9.76,0,0,0,98.67,216H85.5c6.16-95.85,86.07-159.69,184.44-159.69h-.59c98.37,0,178.28,63.84,184.44,159.69H440.62a9.76,9.76,0,0,0-9.81,9.71h0V371a9.74,9.74,0,0,0,9.79,9.71h15.33a9.76,9.76,0,0,0,9.81-9.69v-1.66c23.75.14,63.4,3.79,63.55-20V327.93l-.38-53.65c-.08-19,4.18-43.3-14.11-48.56L505,221.11C499.94,60.16,363.46,10,269.35,10"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  className: "ba8c1a1e-146c-40a9-ad04-af0100cf39e5",
  d: "M630.25,360.89V211.8h43.5v17.09c7.5-13.2,26.7-21.59,42.9-21.59,21.3,0,36.6,8.7,44.1,23.4,11.7-16.81,26.1-23.4,46.2-23.4,28.21,0,55.21,16.5,55.21,57v96.59h-44.1v-86.4c0-14.1-7.51-25.2-23.71-25.2s-24.9,12.3-24.9,25.5v86.1h-45v-86.4c0-14.1-7.5-25.2-24-25.2-15.9,0-24.6,12.3-24.6,25.8v85.8Z"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  className: "ba8c1a1e-146c-40a9-ad04-af0100cf39e5",
  d: "M923.05,139.49a26.7,26.7,0,1,1-26.4,27v-.3A26.82,26.82,0,0,1,923.05,139.49Zm-22.5,221.4V211.8h45.6V360.89Z"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  className: "ba8c1a1e-146c-40a9-ad04-af0100cf39e5",
  d: "M1021.45,286.5l-52.21-74.7H1023l26.7,40.79,26.09-40.79h51l-51.6,72.9c16.8,24,36.3,52.2,53.4,76.2h-53.4l-27.61-42c-8.09,12-19.2,29.7-27.3,42h-50.1Z"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  className: "ba8c1a1e-146c-40a9-ad04-af0100cf39e5",
  d: "M1151.64,360.89V211.8h43.5v17.09c7.5-13.2,26.7-21.59,42.9-21.59,21.3,0,36.6,8.7,44.1,23.4,11.7-16.81,26.1-23.4,46.2-23.4,28.2,0,55.2,16.5,55.2,57v96.59h-44.1v-86.4c0-14.1-7.5-25.2-23.7-25.2s-24.9,12.3-24.9,25.5v86.1h-45v-86.4c0-14.1-7.5-25.2-24-25.2-15.9,0-24.6,12.3-24.6,25.8v85.8Z"
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  className: "ba8c1a1e-146c-40a9-ad04-af0100cf39e5",
  d: "M1585.73,360.89V143.69h45.6v217.2Z"
});

var _ref17 = /*#__PURE__*/React.createElement("path", {
  className: "ba8c1a1e-146c-40a9-ad04-af0100cf39e5",
  d: "M1671.53,360.89V143.69h45.6v217.2Z"
});

var _ref18 = /*#__PURE__*/React.createElement("path", {
  className: "ba8c1a1e-146c-40a9-ad04-af0100cf39e5",
  d: "M1904.93,286.2c0,46.2-34.5,79.2-79.2,79.2-44.4,0-79.2-33-79.2-79.2s34.8-78.9,79.2-78.9C1870.43,207.3,1904.93,240,1904.93,286.2Zm-45.6,0c0-25.2-16.2-36.9-33.6-36.9-17.1,0-33.6,11.7-33.6,36.9,0,24.9,16.5,37.2,33.6,37.2C1843.13,323.4,1859.33,311.4,1859.33,286.2Z"
});

var _ref19 = /*#__PURE__*/React.createElement("path", {
  d: "M1556.49,315.75c-7.2,25.8-30.9,47.4-68.7,47.4-41.11,0-77.71-29.4-77.71-79.51,0-48,35.7-78.6,74.41-78.6,46.2,0,74.7,28.5,74.7,76.51a95,95,0,0,1-.9,14.1H1454.48c.9,16.8,16.2,28.8,33.9,28.8,16.5,0,25.81-7.8,30-19.5Zm-41.4-49.51c-.6-11.4-8.4-25.2-30-25.2-19.21,0-28.8,14.1-29.71,25.2Z"
});

function SvgLogoInverse(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "bc835a82-5441-4e51-8bff-b3350f669cd4",
    "data-name": "b6edf2a6-14b6-4967-96e9-92d46e85a117",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1904.93 492",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoInverse);
export default __webpack_public_path__ + "static/media/logo-inverse.3aaa4d72.svg";
export { ForwardRef as ReactComponent };